<script>
	import SwimmerIcon from "svelte-icons/fa/FaSwimmer.svelte";
	import SkullIcon from "svelte-icons/fa/FaSkull.svelte";

	export let lives = 3;
	export let size = 50;
	export let isOut = false;

	$: lifeStyle = `height: ${size}px;`
	$: iconStyle = `height: ${size / 1.5}px; width: ${size / 1.5}px;`
</script>

{#if isOut}
	<div class="icon" style={iconStyle}>
		<SkullIcon />
	</div>
{:else}
	{#if lives > 0}
		{#each Array(lives) as _}
			<div class="life" style={lifeStyle} />
		{/each}
	{:else}
		<div class="icon" style={iconStyle}>
			<SwimmerIcon />
		</div>
	{/if}
{/if}

<style>
	.life {
		background-color: #E6BF83;
		width: 3px;
		margin-right: 4px;

		border-top-style: solid;
		border-top-color: #FF0000;
		border-top-width: 6px;
	}

	.icon {
		margin-right: 8px;
	}
</style>